/* eslint-disable max-len */
import 'react';

let index = 0;
const OpenPersonSvg = (props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;

    const getId = (id: string) => {
        return `OpenPersonSvg${timeStamp}-${id}`;
    };

    return (<svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" {...props}>
        <g fill="none" fillRule="evenodd">
            <circle fill="#F2F6FF" cx={16} cy={16} r={16} />
            <g transform="translate(9 8)">
                <path
                    d="M8 7c1.014 0 1.94.378 2.646 1H9a1 1 0 0 0-1 1v6H2a2 2 0 0 1-2-2v-2a4 4 0 0 1 4-4h4ZM6 0a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z"
                    fill="#709FFF"
                />
                <path
                    d="M10 9h2.5a2.5 2.5 0 0 1 2.5 2.5V14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z"
                    fill="#709FFF"
                />
                <rect fill="#FFF" x={10.5} y={10.5} width={3} height={1} rx={0.3} />
                <rect fill="#FFF" x={10.5} y={12.5} width={3} height={1} rx={0.3} />
            </g>
        </g>
    </svg>);
};

export default OpenPersonSvg;
